export const ContentContainerId = "content_container_id";
export const ContentSectionId = "content_section_id";
export const CoachesSectionId = "coaches_section_id";
